module.exports = __webpack_public_path__ + "img/summarize.234fbecd.svg";